import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import Signup from './components/Signup';
import Home from './components/Home';
import Home1 from './components/Home/index-home';
import About from './components/About';
import Platform from './components/Platform';
import Contact from './components/Contact';
import AddressScore from './components/AddressScore';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './store';
import { SnackbarProvider } from 'notistack';
import MainLayout from './MainLayout';
import NotFound from './components/NotFound';
import AddressNotFound from './components/AddressNotFound';
import Embed from './components/Embed';
import Plugin from './components/Plugin';
import ConfirmSignup from './components/Signup/confirm-signup';
import ResetPassword from './components/ForgotPassword/reset-password';
import { QueryClient, QueryClientProvider } from 'react-query';
import Navigation from './components/Navigation';
import TwentyMinuteCity from './components/Services/minuteCity';
import RealEstate from './components/Services/realEstate';
import Travel from './components/Services/travel';
import Media from './components/Media';
import ReachedLimit from './components/ReachedLimit';
import HomeSearch from './components/HomeSearch';
import SubscriptionPlans from './components/SubscriptionPlans';
import BookDemo from './components/BookDemo';
import Profile from './components/Profile';
import SuccessCheckout from './components/SuccessCheckout';
import WhyUs from './components/WhyUs';
import FAQs from './components/FAQs';
import Newsletter from './components/Media/newsletter';
import Explore from './components/Explore';
import ExploreThankYou from './components/Explore/thank-you';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <StoreProvider>
      <SnackbarProvider>
        <QueryClientProvider client={queryClient}>
          <MainLayout>
            <Routes>
              <Route path='/login' element={<Login />} />
              <Route path='/forgot-password' element={<ForgotPassword />} />
              <Route path='/signup' element={<Signup />} />
              <Route path='/home' element={<Home />} />
              <Route path='/why-us' element={<WhyUs />} />
              <Route path='/about-us' element={<About />} />
              <Route path='/platform' element={<Platform />} />
              <Route path='/contact-us' element={<Contact />} />
              <Route path='/pricing' element={<SubscriptionPlans withHeader={true} />} />
              <Route path='/book-demo' element={<BookDemo />} />
              <Route path='/services/20-min-city' element={<TwentyMinuteCity />} />
              <Route path='/services/real-estate' element={<RealEstate />} />
              <Route path='/services/travel' element={<Travel />} />
              <Route path='/' element={<App/>} />
              <Route path='/home-test' element={<Home1 />} />
              <Route path='/beta' element={<App />} />
              <Route path='/plugin' element={<App />} />
              <Route path='/plugin/*' element={<App />} />
              <Route path='/address/*' element={<AddressScore />} />
              <Route path='/address-not-found' element={<AddressNotFound />} />
              <Route path='/summary' element={<Plugin />} />
              <Route path='/embed-plugin' element={<Embed />} />
              <Route path='/navigation' element={<Navigation />} />
              <Route path='/media' element={<Media />} />
              <Route path='/activate/:signupCode' element={<ConfirmSignup />} />
              <Route path='/reset-password/:resetPassCode' element={<ResetPassword />} />
              <Route path='/compass' element={<App />} />
              <Route path='/reached-limit' element={<ReachedLimit />} />
              <Route path='/search' element={<HomeSearch />} />
              <Route path='/profile' element={<Profile />} />
              <Route path='/success' element={<SuccessCheckout session_id={new URLSearchParams(window.location.search).get('session_id')} />} />
              <Route path='/faqs' element={<FAQs />} />
              <Route path='/newsletter/:id' element={<Newsletter />} />
              <Route path='/explore/' element={<Explore />} />
              <Route path='/explore/thank-you' element={<ExploreThankYou />} />
            </Routes>
          </MainLayout>
        </QueryClientProvider>
      </SnackbarProvider>
    </StoreProvider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
